import {Box, Stack, TextField, Typography, useTheme} from '@mui/material';
import {translations} from 'presentation/translations-new';
import React from 'react';
import {ObservationTextFieldProps} from '../types';

const {
	notePlaceholder,
	notePlaceholderRequired,
	notFoundProvider,
	notFoundProviderSuggestion,
	notFoundProviderInput,
} = translations['pt-br'].privateFlow.requestAuthorizations.request.ProviderSelection;
const {attachNoteHelperText} =
	translations['pt-br'].privateFlow.requestAuthorizations.request.addAttachments;
const {required} = translations['pt-br'].commons;

export const ObservationTextField = ({
	value,
	onChange,
	error = false,
	maxLength = 2000,
	isRequired = false,
}: ObservationTextFieldProps) => {
	const theme = useTheme();
	const inputFieldLength = value.length;

	const observationPlaceholder = isRequired ? notePlaceholderRequired : notePlaceholder;

	return (
		<Stack gap={1} bgcolor={'background.paper'} p={2} borderRadius={1}>
			<Typography fontWeight={600} color="text.primary">
				{notFoundProvider} {isRequired ? ` (${required.toLowerCase()})` : ''}
			</Typography>
			<Typography variant="body1" color="text.primary">
				{notFoundProviderSuggestion}
			</Typography>
			<Typography variant="body1" color="text.primary">
				{notFoundProviderInput}
			</Typography>
			<TextField
				placeholder={observationPlaceholder}
				slotProps={{
					inputLabel: {sx: {whiteSpace: 'break-spaces'}},
					formHelperText: {
						sx: {
							margin: 0,
						},
					},
				}}
				multiline
				rows={4}
				value={value}
				required={isRequired}
				onChange={event => {
					const {value: inputValue} = event.target;
					if (inputValue.length <= maxLength) {
						onChange(inputValue);
					}
				}}
				error={error}
				helperText={
					<Box sx={{display: 'flex', justifyContent: 'space-between'}}>
						{attachNoteHelperText}
						<Typography
							variant="caption"
							textAlign="end"
							sx={{display: 'inline-block', pl: '12px', marginTop: 'auto'}}>
							{inputFieldLength}/ {maxLength}
						</Typography>
					</Box>
				}
				sx={{
					'& .MuiInputBase-input::placeholder': {
						color: error ? theme.palette.error.main : 'text.secondary',
						opacity: 1,
					},
				}}
			/>
		</Stack>
	);
};
